import { getBooleanFlag } from "lib/flagging/FeatureFlags";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";
import type { IntlShape } from "react-intl";

export default function getPlatformFAQs(intl: IntlShape) {
  return [
    getBooleanFlag("fundamentei/isFreeTrialAvailable")
      ? {
          question: intl.formatMessage({
            defaultMessage: "Vocês disponibilizam um período de testes sem custo?",
            id: "/4F7tZ",
          }),
          answer: [
            intl.formatMessage({
              defaultMessage: "Sim! Você pode ter acesso completo ao plano Premium por até 7 dias sem custo.",
              id: "Rd64kv",
            }),
            intl.formatMessage({
              defaultMessage:
                "O processo é muito simples: você assina normalmente como se fosse pagar o plano com o seu cartão de crédito (Visa ou Mastercard), preenche os dados do seu cartão e sua assinatura será liberada, mas nenhuma cobrança será feita em até 7 dias.",
              id: "3XHj1L",
            }),
            intl.formatMessage({
              defaultMessage:
                "Se você decidir permanecer conosco depois desse prazo, a cobrança será feita automaticamente, até lá você pode testar tudo o que oferecemos, mas caso não queira permanecer, basta cancelar, simples assim.",
              id: "pOvykf",
            }),
          ],
        }
      : null,
    {
      question: intl.formatMessage({
        defaultMessage: "De onde vocês tiram as informações? Posso confiar?",
        id: "bc+TOJ",
      }),
      answer: [
        intl.locale === "pt-BR"
          ? intl.formatMessage({
              defaultMessage:
                "Os dados dos ativos brasileiros são retirados da B3, da CVM e, em alguns casos, dos relatórios (releases) divulgados pelas próprias empresas, ou seja, sempre de fontes oficiais, já os dados de cotações utilizamos a API da Enfoque, que para nós, é a mais confiável do Brasil.",
              id: "aWsu1T",
            })
          : null,
        intl.formatMessage({
          defaultMessage:
            "No caso dos ativos do exterior nós utilizamos a API da Fiscal.ai, cujo os dados são retirados da SEC e dos relatórios (releases) dos ativos, todas fontes oficiais também.",
          id: "eLh4Gq",
        }),
        intl.formatMessage({
          defaultMessage:
            "Caso você veja alguma informação divergente, não deixe de entrar em contato conosco, nos preocupamos sempre em manter os dados mais assertivos no site.",
          id: "ed8wQK",
        }),
      ].filter(notUndefinedOrNull),
    },
    {
      question: intl.formatMessage({
        defaultMessage: "Com qual frequência os dados são atualizados?",
        id: "x201DT",
      }),
      answer: [
        intl.formatMessage({
          defaultMessage: "Atualizamos todas as informações diariamente.",
          id: "EEfNi6",
        }),
        intl.formatMessage({
          defaultMessage:
            "No caso dos ativos do exterior, existe uma diferença entre a data de divulgação dos balanços no site de RI (releases) e a divulgação dos balanços oficiais na SEC (10-Q e 10-K).",
          id: "gG8tQP",
        }),
        intl.formatMessage({
          defaultMessage:
            "A Fiscal.ai retira os dados somente da SEC, por isso pode haver um atraso entre a data que você olha na agenda e a atualização da tabela no Fundamentei.",
          id: "GsGtmO",
        }),
        intl.formatMessage({
          defaultMessage:
            "Essa diferença pode ser de horas ou até dias, mas não é culpa nem nossa e nem da Fiscal.ai, dependemos da própria empresa divulgar na SEC.",
          id: "zFQasV",
        }),
      ],
    },
    {
      question: intl.formatMessage({
        defaultMessage: "Como funciona se eu quiser cancelar a assinatura?",
        id: "ja2bza",
      }),
      answer: [
        intl.formatMessage({
          defaultMessage:
            'Você pode cancelar sua assinatura quando quiser, sem precisar entrar em contato conosco: basta ir no menu, clicar em "Conta" e depois "Gerenciar Assinatura", vai ter um botão de "Cancelar Assinatura", clicando nele seu plano estará cancelado, ou seja, é um processo de poucos segundos.',
          id: "SExyQ+",
        }),
      ],
    },
  ].filter(notUndefinedOrNull);
}
